<style>

/* .card{
  position: relative;
  color: white;
}

.starts-in {
  position: absolute;
  top: 5px;
  left: 5px;
  padding: 5px;
  background-color: rgba(0,0,0,0.6);
}
.stars{
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 5px;
  background-color: rgba(0,0,0,0.6);
}
.info{
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  padding: 5px;
  background-color: rgba(0,0,0,0.6);
} */

.body{
  margin: 0 10px;
}
.name{
  font-size: 21px;
}

.posted-by{
  font-size: 14px;
  margin: 10px 0 20px 0;
}

.rsvp{
  font-size: 14px;
  margin: 20px 0 20px 0;
}

.views{
  font-size: 14px;
  margin: 10px 0;
}

.youll-like{
  font-size: 19px;
  font-family: Sansation;
  font-style: italic;
  margin: 30px 0;
}

.groups{
  position: relative;
  text-align: center;
  color: white;
  margin: 25px;
}
.groups-text{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0,0,0,0.7);
  font-family: Sansation;
  font-size: 21px;
}
.group-img{
  object-fit: scale-down;
  width: 100%;
}

.edit-margin{
  margin-bottom: 5px;
}

.show{
  display: block;
}
.hide{
  display: none;
}
</style>

<Auth bind:this="{auth}"></Auth>

<Header 
back="{true}"
buttons="{ [ {icon: 'icon-calendar_add', text: 'Add Event', callback: 'addEvent', disabled: false, }, ] }"
on:addEvent="{ () => push('/edit-event/new') }"
on:back="{ () => { pop() } }">Event Info</Header>
<div class="has-header"></div>

<!-- is the event loaded?  if so, we can then show the html below -->
<div class="{loaded ? 'show': 'hide'}">

{#if event.uid == myUid}
<div class="edit-margin">
  <button on:click="{ () => push('/edit-event/'+event.eid) }">Edit This Event</button>
</div>
{/if}

<!-- <div class="card">
  
  {#if loaded}
    
    {#if event.photoIds.length == 1}
      <Image src="/ei/cookie/csrf/{event.eid}/{event.photoIds[0]}" style="object-fit: cover; width: 100%;"></Image>
    {/if}
    
    {#if event.photoIds.length > 1}
    
    added {#key...} because of the following link
    https://github.com/vadimkorr/svelte-carousel/issues/29
    {#key event.photoIds}
    <Carousel bind:currentPageIndex="{photoIndex}">
      {#each event.photoIds as item}
        <div class="car-pic-cont">
          <img src="https://routes.hot0.workers.dev/ei/{localStorage.getItem('cookie')}/{localStorage.getItem('csrf')}/{event.eid}/{item}" class="car-pic">
        </div>
      {/each}
    </Carousel>
    {/key}
    
    {/if}
    
    <div class="starts-in"><StartsIn currentTime="{currentTime}" start="{event.start}" end="{event.end}"></StartsIn></div>
    
    <div class="stars"><Stars stars="{event.stars}" readWrite="{starsReadWrite}" largeStars="{false}" on:updated="{starsUpdated}"></Stars></div>
    
    <div class="info">
      <div><EventTime start="{event.start}" end="{event.end}"></EventTime></div>
    </div>

  {/if}
  
</div> -->

<!-- <EventCard item="{event}" currentTime="{currentTime}" on:click="{}"></EventCard> -->
<EventCard item="{event}" currentTime="{currentTime}" showName="{false}"></EventCard>


<div class="body">
  <div class="name">{event.ename}</div>
  
  {#if event.type == 1}
    <div class="posted-by">posted by <a href="/business-profile/123" use:link>The Grove Bar and Restaurant</a></div>
  {:else}
    <div class="posted-by">posted by @{event.username}</div>
  {/if}
  
  <div>
    <ImGoing going="{isGoing}" on:going="{going}" on:cancel="{cancel}"></ImGoing>
  </div>
  
  {#if attendingString}
    <div class="rsvp">
      {attendingString}
    </div>
  {:else}
    <div class="rsvp">No attending so far...</div>
  {/if}
  
  {#if event.phone}
  <InfoBox icon="phone">{event.phone}</InfoBox>
  {/if}
  <InfoBox icon="address"><div id="address"></div></InfoBox>
  <InfoBox icon="price">{event.price}</InfoBox>
  
  {#each event.links as item}
    <InfoBox icon="{item.icon}">{item.link}</InfoBox>
  {/each}
  
  <h3>Description</h3>
  
  <div class="description">
    {event.details}
  </div>
  
  <div class="views">
    {event.views} people have looked at this
  </div>
  
  <!-- <div class="youll-like">Groups we think you'll like based on this event</div> -->
  
</div>

<!-- <div class="groups">
  <img src="/i/new-mexico-wine-tasting.jpg" class="group-img">
  <div class="groups-text">
    New Mexico Wine Tasting
  </div>
</div>

<div class="groups">
  <img src="/i/raver-babies.jpg" class="group-img">
  <div class="groups-text">
    Albuquerque Raver Babies
  </div>
</div> -->

<!-- if loaded -->
</div>

<div class="has-action-bar"></div>
<ActionBar></ActionBar>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';
export let params = {};

import Auth from "../interfaces/Auth.svelte";
let auth;

import Xss from "../helpers/Xss.js";

import UnitedStates from "../addresses/UnitedStates.js";
// import Indonesia from "../addresses/Indonesia.js";

let countryForms = {
  "us": UnitedStates,
  // "id": Indonesia,
}

import Carousel from "../../node-overriden/svelte-carousel";

import DateTime from "../helpers/DateTime.js";

import Header from "../components/Header.svelte";
import Image from "../components/Image.svelte";
import Stars from "../components/Stars.svelte";
import EventTime from "../components/EventTime.svelte";
import StartsIn from "../components/StartsIn.svelte";
import InfoBox from "../components/InfoBox.svelte";
import ActionBar from "../components/ActionBar.svelte";
import ImGoing from "../components/ImGoing.svelte";
import EventCard from "../components/EventCard.svelte";


let loaded = false;
let photoIndex;
let height = 100;

let interval = null;
let currentTime =  Math.round( Date.now() / 1000 );

let event = {
  uid: "",
  eid: "",
  photoIds: [],
  ename: "",
  start: 0,
  end: 0,
  country: "",
  address: {address: "", address2: "", city: "", state: "", zip: ""},
  phone: "",
  price: "",
  details: "",
  links: [],
  type: 0,
  username: "",
  stars: 0,
}

let attendingString = "";
let isGoing = false;
let starsReadWrite = false;

// get my uid from local storage
let myUid = JSON.parse( localStorage.getItem("store") )["uid"];

import { onMount } from "svelte";
onMount(async () => {
  // update the event times every X minutes
  interval = setInterval( () => { 
    currentTime =  Math.round( Date.now() / 1000 );
    if (currentTime > event.start) starsReadWrite = true;
  }, 1000 * 60 * 1);
  
  auth.message("Loading Event");
  
  try {
    
    let rec = await auth.post("eventInfo", {eid: params.eid} );
    rec = Xss.filter(rec);
    event = JSON.parse(rec);
    
    console.log("event:", event);
    
    // fix up the dates and times
    
    let dt = DateTime.splitDate(event.start);
    let date = new Date(dt.year, dt.month, dt.date, dt.hour, dt.minutes, dt.seconds);
    event.start = Math.round(date.getTime() / 1000);
    
    dt = DateTime.splitDate(event.end);
    date = new Date(dt.year, dt.month, dt.date, dt.hour, dt.minutes, dt.seconds);
    event.end = Math.round(new Date(date).getTime() / 1000);
    
    // localize phone and address
    event.phone = countryForms[event.country].phone(event.phone);
    event.address = countryForms[event.country].address(event.address);
    // this is secure, because we do some XSS filtering on save _and_ load
    document.getElementById("address").innerHTML = event.address;
    
    buildAttending();
    
    if (currentTime > event.start) starsReadWrite = true;
    
    loaded = true;
    
  } catch (error) {
    console.log("error:", error);
  }
  
});


function buildAttending() {
  
  
  // set up for connected friends
  // event.attending = ["uid", "uid", etc...];
  // we receive uids, because if a user is connected to another user,
  // that user info will already be on our device and we can connect
  // the user via that info.
  
  // associate attendee uids with local stored name info
  let localAttending = [];
  let attendeeCount = event.attending.length;
  
  // is my uid in the list?
  let index = event.attending.indexOf(myUid);
  if (index != -1) {
    // remove from list
    event.attending.splice(index, 1);
    localAttending.push("I'm going");
    isGoing = true;
    attendeeCount--;
  }
  
  // as we're scanning for friends, if we don't see any that connect
  // we delete them from the array until it's empty
  // for (let i in event.attending) {
  //   if () {
      
  //   }
  // }
  
  attendingString = "";
  if (localAttending.length > 0) {
    // build attending string
    for (let i in localAttending) {
      attendingString += (i > 0 ? ", " : "") + localAttending[i];
    }
  }
  
  if (localAttending.length == 0 && attendeeCount > 0) {
    attendingString += "+" + attendeeCount + " others going";
  } else if (localAttending.length > 0 && attendeeCount > 0) {
    attendingString += ", +" + attendeeCount + " others going";
  } else if (localAttending.length > 1 && attendeeCount == 0) {
    attendingString += " going";
  }
  
}


async function going() {
  // console.log("going");
  
  if (event.eid == "") return;
  
  // add uid to the front of event.attending
  event.attending.unshift(myUid);
  buildAttending();
  
  try {
    let res = await auth.post("eventAttendance", {eid: event.eid, going: true}, false);
  } catch (error) {
    console.log("error:", error);
  }
  
}


async function cancel() {
  // console.log("cancel");
  
  if (event.eid == "") return;
  
  // remove uid from event.attending
  event.attending.splice( event.attending.indexOf(myUid), 1 );
  buildAttending();
  
  try {
    let res = await auth.post("eventAttendance", {eid: event.eid, going: false}, false);
  } catch (error) {
    console.log("error:", error);
  }
  
}


async function starsUpdated(e) {
  // console.log("e.detail:", e.detail);
  
  try {
    
    let res = await auth.post("starsUpdated", {eid: event.eid, stars: e.detail.stars}, false);
    
  } catch (error) {
    console.log("starsUpdated error:", error);
  }
}


</script>